module.exports = __webpack_public_path__ + "static/media/about4.89ed23f4.jpg";